import React from 'react';

import { cn } from '../../lib/utils';
import type { Message } from './types';

interface ConversationMessageUserProps {
  message: Message;
  className?: string;
}

export const ConversationMessageUser = ({ message, className }: ConversationMessageUserProps) => {
  const paragraphs = message.content
    .filter((b): b is { type: 'text'; text: string } => b.type === 'text')
    .map((b) => b.text)
    .join('\n')
    .split(/\n\n+/);

  return (
    <div className={cn('flex justify-end py-4', className)}>
      <div className="max-w-[85%] rounded bg-surface px-4 py-2.5 text-foreground">
        {paragraphs.map((paragraph, i) => (
          <p key={i} className="m-0 mb-4 whitespace-pre-wrap last:mb-0">
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
};
